import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/video/postlink/getList',
        method: 'get',
        params: query
    })
}
// 组件列表
export function details(query) {
    return axios({
        url: '/video/postlink/details',
        method: 'get',
        params: query
    })
}
// 添加
export function add(query) {
    return axios({
        url: '/video/postlink/addInfo',
        method: 'post',
        data: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/postlink/delete',
        method: 'get',
        params: query
    })
}
//禁用
export function disable(query) {
    return axios({
        url: '/video/postlink/disable',
        method: 'get',
        params: query
    })
}
